import { createPortal } from 'react-dom'
import { GUIA_LABELS } from '@utils/guiaLabels.js'
import { Link } from 'react-router-dom'
import { ROUTES, topicoDetailPath } from '@utils/constants.js'
import type { PassoJornada } from '@content/jornada.js'

interface Props {
  anterior: PassoJornada | null
  proximo: PassoJornada | null
  jaConcluido: boolean
  onToggleConcluido: () => void
  salvando?: boolean
}

function PassoNavBarContent({
  anterior,
  proximo,
  jaConcluido,
  onToggleConcluido,
  salvando,
}: Props) {
  return (
    <div className='cf3-passo-nav' role='navigation' aria-label={GUIA_LABELS.navegacaoDaEtapa}>
      <div className='cf3-passo-nav__side cf3-passo-nav__side--prev'>
        {anterior ? (
          <Link
            to={topicoDetailPath(anterior.moduloId, anterior.topicoId)}
            className='cf3-passo-nav__link'
          >
            ← Anterior
          </Link>
        ) : (
          <span className='cf3-passo-nav__placeholder' aria-hidden />
        )}
      </div>

      <button
        type='button'
        className={[
          'cf3-passo-nav__link',
          'cf3-passo-nav__concluir',
          jaConcluido ? 'cf3-passo-nav__concluir--done' : '',
        ]
          .filter(Boolean)
          .join(' ')}
        onClick={onToggleConcluido}
        disabled={salvando}
        aria-label={
          jaConcluido ? GUIA_LABELS.desmarcarEtapaConcluida : GUIA_LABELS.marcarEtapaConcluida
        }
      >
        {jaConcluido ? 'Concluído' : GUIA_LABELS.concluirEtapa}
      </button>

      <div className='cf3-passo-nav__side cf3-passo-nav__side--next'>
        {proximo ? (
          <Link
            to={topicoDetailPath(proximo.moduloId, proximo.topicoId)}
            className='cf3-passo-nav__link'
          >
            Próximo →
          </Link>
        ) : (
          <Link to={ROUTES.MODULOS} className='cf3-passo-nav__link'>
            Jornada →
          </Link>
        )}
      </div>
    </div>
  )
}

export function PassoNavBar(props: Props) {
  const shell = typeof document !== 'undefined' ? document.getElementById('app') : null
  const bar = <PassoNavBarContent {...props} />
  return shell ? createPortal(bar, shell) : bar
}
